import { Flex, Spin } from "antd"

import PerkCard from "./PerkCard"

import "./PerksList.less"

const PerksList = ({ data, loading, emptyComponent, onSelectRow, onToggleVisibility }) => {
  return (
    <Spin spinning={loading}>
      {data.length === 0 && (
        <Flex align="center" justify="center">
          {emptyComponent}
        </Flex>
      )}
      <div className="perks-cards-list">
        {data.map((item) => (
          <PerkCard
            key={item.id}
            perk={item}
            onSelectRow={onSelectRow}
            onToggleVisibility={onToggleVisibility}
          />
        ))}
      </div>
    </Spin>
  )
}

export default PerksList
